import { ChangeEvent, ReactNode } from 'react';
import clsx from 'clsx';

type RadioLinkItemProps = {
  className?: string;
  variant?: 'button-group' | 'radio-group';
  checked: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  children: ReactNode;
};

export const RadioLinkItem = ({
  className,
  variant = 'radio-group',
  checked,
  onChange,
  children,
}: RadioLinkItemProps) => {
  if (variant === 'button-group') {
    return (
      <label
        className={clsx(
          'flex cursor-pointer items-center justify-center px-4 py-2 text-center text-sm font-semibold',
          'hover:bg-neutral-900 hover:text-white',
          'focus-visible:shadow-[0_0_0_2px_var(--white)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus aria-disabled:pointer-events-none aria-disabled:opacity-50',
          checked ? 'bg-black text-white' : 'bg-neutral-100 text-black',
          className
        )}
      >
        <input type="radio" className="sr-only" checked={checked} onChange={onChange} />
        <span>{children}</span>
      </label>
    );
  }

  return (
    <label
      className={clsx(
        'group flex cursor-pointer items-center gap-2 text-sm outline-none',
        className
      )}
    >
      <input
        type="radio"
        checked={checked}
        onChange={onChange}
        className={clsx(
          'relative block size-5 shrink-0 appearance-none rounded-full border-2 border-black group-hover:border-neutral-800 focus-visible:shadow-[0_0_0_2px_var(--white)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus',
          checked &&
            'after:absolute after:inset-[calc(--spacing(1)_*_0.75)] after:size-2.5 after:rounded-full after:bg-black group-hover:after:bg-neutral-900'
        )}
      />
      <span className="whitespace-nowrap group-hover:text-neutral-800">{children}</span>
    </label>
  );
};
